var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chainId)?_c('span',[_vm._v("\n  "+_vm._s(_vm.network.name)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }